// extracted by mini-css-extract-plugin
export default {"overlay":"Sy-z","bodyOpen":"Ty-z","content":"Uy-z","header":"Vy-z","close":"Wy-z","closeNoHeading":"Xy-z"};